import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Clock, Calendar } from "lucide-react";
import { BLOG_POSTS } from "../data/content";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="pt-32 pb-24 text-center">
        <p className="text-white/60">Article introuvable.</p>
        <Link to="/blog" className="btn-secondary mt-6 inline-flex">Retour au blog</Link>
      </div>
    );
  }

  const related = BLOG_POSTS.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <article data-testid="blog-post-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Link to="/blog" className="text-white/60 hover:text-[#7DD923] text-sm flex items-center gap-2 mb-8">
          <ArrowLeft className="w-4 h-4" /> Tous les articles
        </Link>
        <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">{post.category}</div>
        <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">{post.title}</h1>
        <div className="flex items-center gap-4 text-white/50 text-sm mt-6">
          <span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {post.date}</span>
          <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {post.readTime}</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-10 mt-10">
        <div className="rounded-3xl overflow-hidden border border-white/5 aspect-[16/9]">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-10 mt-12">
        <div className="prose prose-invert max-w-none">
          {post.content.split("\n\n").map((para, i) => {
            if (para.startsWith("**") && para.endsWith("**")) {
              return <h3 key={i} className="font-display uppercase text-[#7DD923] text-xl mt-8 mb-3">{para.replaceAll("**","")}</h3>;
            }
            const parts = para.split("**");
            return (
              <p key={i} className="text-white/80 leading-relaxed mb-4">
                {parts.map((t, k) => (k % 2 === 1 ? <strong key={k} className="text-white">{t}</strong> : <span key={k}>{t}</span>))}
              </p>
            );
          })}
        </div>

        <div className="mt-12 glass rounded-2xl p-6 md:p-8">
          <div className="eyebrow">Vous voulez démarrer ?</div>
          <h3 className="font-display uppercase text-white text-2xl mt-3">Obtenez votre étude gratuite</h3>
          <p className="text-white/70 text-sm mt-2">Nos experts vous accompagnent gratuitement de A à Z.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <Link to="/devis" className="btn-primary">Étude gratuite <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/simulateur" className="btn-secondary">Simuler mes aides</Link>
          </div>
        </div>
      </div>

      {related.length > 0 && (
        <div className="max-w-7xl mx-auto px-6 md:px-10 mt-20">
          <h3 className="font-display uppercase text-white text-3xl mb-6">Sur le même sujet</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {related.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-[#121212] border border-white/5 rounded-2xl overflow-hidden hover:border-[#7DD923]/40 transition-colors">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">{p.category}</div>
                  <h4 className="font-display text-white text-lg mt-2 tracking-tight group-hover:text-[#7DD923]">{p.title}</h4>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </article>
  );
}
